{
  "edit": {
    "title": "Student Profile"
  },
  "form": {
    "common": {
      "comments": "Comments",
      "examinee_id": "Examinee ID",
      "date_of_testing": "Date of Testing",
      "date_of_report": "Date of Report",
      "year_grade": "Year/Grade",
      "handedness": "Handedness",
      "examiner_name": "Examiner Name"
    },
    "sections": {
      "general_information": "General Information",
      "parent_information": "Parent Information",
      "ability": "Ability",
      "learning_styles": "Learning Styles",
      "learning_preferences": "Learning Preferences",
      "other_informations": "Other Informations"
    },
    "general_information_section": {
      "photo_id": "Photo Id",
      "first_name": "First Name",
      "last_name": "Last Name",
      "email": "Email",
      "dob": "Date of Birth",
      "gender": "Gender",
      "religion": "Religion",
      "race": "Race",
      "primary_language": "Primary Language",
      "secondary_language": "Secondary Language",
      "has_aeas_score": "Has AEAS Score",
      "citizenship": "Citizenship",
      "country_of_origin": "Country of Origin",
      "tooltips": {
        "religion": "Religion according to <a>Australian Standard Classification of Religious Groups</a>",
        "race": "Race according to <a>Australian Standard Classification of Cultural and Ethnic Groups</a>",
        "country": "Country according to <a>Standard Australian Classification of Countries</a>",
        "language": "Language according to <a>Australian Standard Classification of Languages</a>"
      }
    },
    "ability_section": {
      "subsections": {
        "school_qualitative_assessment": "School Qualitative Assessment",
        "naplan_score": "NAPLAN Score (Year 9)",
        "gat": "GAT (VIC)",
        "wais_iv": "WAIS IV",
        "wisc_v": "WISC V",
        "wiat_iv": "WIAT IV",
        "aeas": "AEAS"
      },
      "school_qualitative_assessment": {
        "overall_qualitative_assessment": "Overall (school estimate of IQ equivalent)",
        "overall_qualitative_assessment_comments": "$t(form.common.comments)",
        "interested_subjects": {
          "title": "Interested Subjects",
          "index_title": "$t(form.ability_section.school_qualitative_assessment.interested_subjects.title) {{index}}",
          "subject_id": "Subject",
          "qualitative_assessment": "Qualitative Assessment",
          "add_button": "Add Interested Subject",
          "remove_label": "Remove Interested Subject {{index}}"
        }
      },
      "naplan": {
        "naplan_score_numeracy": "Numeracy",
        "naplan_score_reading": "Reading",
        "naplan_score_writing": "Writing",
        "naplan_score_grammar": "Convention of Language - Grammar",
        "naplan_score_spelling": "Convention of Language - Spelling",
        "naplan_chart": "NAPLAN Chart"
      },
      "gat": {
        "writing_met_standard_score": "Writing Met Standard Score",
        "writing_achieved_excellence": "Writing Achieved Excellence",
        "reading_met_standard_score": "Reading Met Standard Score",
        "reading_achieved_excellence": "Reading Achieved Excellence",
        "numeracy_met_standard_score": "Numeracy Met Standard Score",
        "numeracy_achieved_excellence": "Numeracy Achieved Excellence",
        "written_score": "Writing and Written Communications",
        "reading_score": "Reading and Humanities /Arts/Social Sciences",
        "numeracy_score": "Numeracy and Mathematics/Science/Technology"
      },
      "aeas": {
        "tooltips": {
          "section": "<link1>Australian Education Assessment Services</link1> (AEAS) offers a testing service comprising general ability, mathematical reasoning and English proficiency tests for schools accepting enrolments from international students and wishing to gauge their readiness for academic study in Australia. The LTRC has developed prototypes and parallel versions of the AEAS English language tests for upper primary and secondary school (Years 4-6, Years 7-9, Years 10-12).<br/><link2>Here is a sample report.</link2>"
        },
        "aeas_score_reading": "Reading Comprehension",
        "aeas_score_spelling": "Spelling",
        "aeas_score_written_essay": "Written Essay",
        "aeas_score_listening": "Listening",
        "aeas_score_speaking": "Speaking",
        "aeas_score_overall": "Overall"
      },
      "wais_iv": {
        "tooltips": {
          "section": "The WAIS-IV is the 'gold standard' in cognitive assessment and claims to measure intellectual performance. The age range for WAIS-IV is 16 years to 90 years and 11 months. One Full Scale IQ (FSIQ) is calculated as well as scores for: Verbal Comprehension Index, Perceptual Reasoning Index, Working Memory Index, and Processing Speed Index. <br/> <link1>Here is the distributor of the WAIS-IV test.</link1> <br/><link2>Here is a sample report</link2>"
        },
        "wais_iv_full_scale_iq_index": "Full Scale IQ (FSIQ) Score",
        "wais_iv_full_scale_iq_percentile_rank": "Full Scale IQ (FSIQ) Percentile Rank",
        "wais_iv_general_ability_index": "General Ability Index Score",
        "wais_iv_general_ability_percentile_rank": "General Ability Index (GAI) Percentile Rank",
        "wais_iv_verbal_comprehension_index": "Verbal Comprehension Index (VCI) Score",
        "wais_iv_verbal_comprehension_percentile_rank": "Verbal Comprehension Index (VCI) Percentile Rank",
        "wais_iv_perceptual_reasoning_index": "Perceptual Reasoning Index (PRI) Score",
        "wais_iv_perceptual_reasoning_percentile_rank": "Perceptual Reasoning Index (PRI) Percentile Rank",
        "wais_iv_working_memory_index": "Working Memory Index (WMI) Score",
        "wais_iv_working_memory_percentile_rank": "Working Memory Index (WMI) Percentile Rank",
        "wais_iv_processing_speed_index": "Processing Speed Index (PSI) Score",
        "wais_iv_processing_speed_percentile_rank": "Processing Speed Index (PSI) Percentile Rank"
      },
      "wisc_v": {
        "tooltips": {
          "section": "The Wechsler Intelligence Scale for children - fifth edition, Australian standard assesses the general thinking and reasoning skills of children aged six years to 16 years. Results include a full-scale intelligence quotient (IQ)) score as well as age-equivalent rankings and scores for verbal comprehension, visual spatial, fluid reasoning, working memory and processing speed composites. The wisc-v can be used for purposes of identifying an intellectual disability, giftedness, specific learning disabilities, placement in specialised programs and clinical intervention.<br/><link1>Here is the distributor of the report.</link1><br/><link2>Here is a sample report</link2>"
        },
        "exam_id": "$t(form.common.examinee_id)",
        "test_date": "$t(form.common.date_of_testing)",
        "report_date": "$t(form.common.date_of_report)",
        "grade": "$t(form.common.year_grade)",
        "handedness": "$t(form.common.handedness)",
        "examiner_name": "$t(form.common.examiner_name)",
        "fsiq_score": "Full Scale IQ (FSIQ) Score",
        "fsiq_percentile": "Full Scale IQ (FSIQ) Percentile Rank",
        "fri_score": "Fluid Reasoning Index (FRI) Score",
        "fri_percentile": "Fluid Reasoning Index (FRI) Percentile Rank",
        "vci_score": "Verbal Comprehension Index (VCI) Score",
        "vci_percentile": "Verbal Comprehension Index (VCI) Percentile Rank",
        "vsi_score": "Visual Spatial Index (VSI) Score",
        "vsi_percentile": "Visual Spatial Index (VSI) Percentile Rank",
        "wmi_score": "Working Memory Index (WMI) Score",
        "wmi_percentile": "Working Memory Index (WMI) Percentile Rank",
        "psi_score": "Processing Speed Index (PSI) Score",
        "psi_percentile": "Processing Speed Index (PSI) Percentile Rank"
      },
      "wiat_iv": {
        "tooltips": {
          "section": "<link1>The Wechsler Individual Achievement Test® (WIAT®)</link1> is an individually administered achievement test for ages 4–50 (grades PreK–12+). It is used to gauge and assess a person's academic skills and accomplishments across various domains, particularly those surrounding early reading skills, oral language, math fluency, and writing fluency.<br/><link2>Difference between WIAT and WISC.</link2><br/><link3>Here is the sample report.</link3>"
        },
        "exam_id": "$t(form.common.examinee_id)",
        "test_date": "$t(form.common.date_of_testing)",
        "report_date": "$t(form.common.date_of_report)",
        "age_at_test": "Age at test",
        "grade": "$t(form.common.year_grade)",
        "handedness": "$t(form.common.handedness)",
        "examiner_name": "$t(form.common.examiner_name)",
        "semester": "Semester",
        "is_retest": "Is this a retest?",
        "total_achievement_composite_score": "Total Achievement Composite Score",
        "total_achievement_composite_percentile": "Total Achievement Composite Percentile Rank",
        "word_reading_score": "Word Reading Score",
        "word_reading_percentile": "Word Reading Percentile Rank",
        "reading_comprehension_score": "Reading Comprehension Score",
        "reading_comprehension_percentile": "Reading Comprehension Percentile Rank",
        "spelling_score": "Spelling Score",
        "spelling_percentile": "Spelling Percentile Rank",
        "sentence_composition_score": "Sentence Composition Score",
        "sentence_composition_percentile": "Sentence Composition Percentile Rank",
        "math_problem_solving_score": "Math Problem Solving Score",
        "math_problem_solving_percentile": "Math Problem Solving Percentile Rank",
        "numerical_operations_score": "Numerical Operations Score",
        "numerical_operations_percentile": "Numerical Operations Percentile Rank",
        "reading_composite_score": "Reading Composite Score",
        "reading_composite_percentile": "Reading Composite Percentile Rank",
        "written_expression_composite_score": "Written Expression Composite Score",
        "written_expression_composite_percentile": "Written Expression Composite Percentile Rank",
        "mathematics_composite_score": "Mathematics Composite Score",
        "mathematics_composite_percentile": "Mathematics Composite Percentile Rank",
        "basic_reading_composite_score": "Basic Reading Composite Score",
        "basic_reading_composite_percentile": "Basic Reading Composite Percentile Rank",
        "decoding_composite_score": "Decoding Composite Score",
        "decoding_composite_percentile": "Decoding Composite Percentile Rank",
        "reading_fluency_composite_score": "Reading Fluency Composite Score",
        "reading_fluency_composite_percentile": "Reading Fluency Composite Percentile Rank",
        "math_fluency_composite_score": "Math Fluency Composite Score",
        "math_fluency_composite_percentile": "Math Fluency Composite Percentile Rank",
        "writing_fluency_composite_score": "Writing Fluency Composite Score",
        "writing_fluency_composite_percentile": "Writing Fluency Composite Percentile Rank",
        "oral_language_composite_score": "Oral Language Composite Score",
        "oral_language_composite_percentile": "Oral Language Composite Percentile Rank",
        "phonological_processing_composite_score": "Phonological Processing Composite Score",
        "phonological_processing_composite_percentile": "Phonological Processing Composite Percentile Rank",
        "orthographic_processing_composite_score": "Orthographic Processing Composite Score",
        "orthographic_processing_composite_percentile": "Orthographic Processing Composite Percentile Rank",
        "orthographic_processing_extended_composite_score": "Orthographic Processing Extended Composite Score",
        "orthographic_processing_extended_composite_percentile": "Orthographic Processing Extended Composite Percentile Rank",
        "dyslexia_index_composite_score": "Dyslexia Index Composite Score",
        "dyslexia_index_composite_percentile": "Dyslexia Index Composite Percentile Rank"
      }
    },
    "learning_style_section": {
      "subsections": {
        "learning_style_description": "Learning Style Description",
        "vark": "VARK",
        "gardners_multiple_intelligences": "Gardner's Multiple Intelligences",
        "kolbs_experiential_learning_theory": "Kolb's Experiential Learning Theory"
      },
      "tooltips": {
        "vark": {
          "section": "VARK (Visual, Auditory, Reading/Writing, Kinesthetic): (see <link1>here</link1> for a useful link)",
          "rows": {
            "student.learning_style_visual": "Prefers learning through images, diagrams, charts, and other visual aids.",
            "student.learning_style_auditory": "Prefers learning through listening to spoken information, lectures, discussions, and audio materials.",
            "student.learning_style_read_write": "Prefers learning through reading texts and writing notes, essays, and written explanations.",
            "student.learning_style_kinesthetic": "Prefers learning through hands-on activities, experiments, and physical movement."
          }
        },
        "gardners_multiple_intelligences": {
          "section": "Gardner's Multiple Intelligences (see <link1>here</link1> for a useful link)",
          "rows": {
            "student.learning_style_linguistic": "Strong in reading, writing, and verbal communication",
            "student.learning_style_logical": "Excel in reasoning, problem-solving, and understanding abstract concepts.",
            "student.learning_style_musical": "Sensitive to sounds, rhythms, and music, may excel in playing instruments or understanding music theory.",
            "student.learning_style_spatial": "Good at visualizing, understanding maps, diagrams, and spatial relationships.",
            "student.learning_style_body_kinesthetic": "Skilled in physical activities, sports, or hands-on tasks.",
            "student.learning_style_interpersonal": "Strong in understanding others, working in groups, and communicating effectively.",
            "student.learning_style_intrapersonal": "Good at self-reflection, understanding one's own emotions and motivations.",
            "student.learning_style_naturalistic": "Sensitive to nature, enjoys working with plants, animals, or outdoor activities."
          }
        },
        "kolbs_experiential_learning_theory": {
          "section": "Kolb's Experiential Learning Theory (see <link1>here</link1> and <link2>here</link2>)",
          "rows": {
            "student.learning_style_concrete_exp": "Prefers learning through direct experience, hands-on activities, and feeling things out.",
            "student.learning_style_reflective_obs": "Prefers learning by watching others, reflecting on experiences, and considering multiple perspectives.",
            "student.learning_style_abstract_conc": "Prefers learning through logical analysis, thinking through theories, and planning systematically.",
            "student.learning_style_active_exp": "Prefers learning by testing ideas, trying out new solutions, and applying concepts in practical scenarios."
          }
        }
      },
      "vark": {
        "student.learning_style_visual": "Visual",
        "student.learning_style_auditory": "Auditory",
        "student.learning_style_kinesthetic": "Kinesthetic",
        "student.learning_style_read_write": "Reading/Writing"
      },
      "gardners_multiple_intelligences": {
        "student.learning_style_linguistic": "Linguistic",
        "student.learning_style_logical": "Logical-Mathematical",
        "student.learning_style_musical": "Musical",
        "student.learning_style_spatial": "Spatial",
        "student.learning_style_body_kinesthetic": "Bodily-Kinesthetic",
        "student.learning_style_interpersonal": "Interpersonal",
        "student.learning_style_intrapersonal": "Intrapersonal",
        "student.learning_style_naturalistic": "Naturalistic"
      },
      "kolbs_experiential_learning_theory": {
        "student.learning_style_concrete_exp": "Concrete Experience (CE)",
        "student.learning_style_reflective_obs": "Reflective Observation (RO)",
        "student.learning_style_abstract_conc": "Abstract Conceptualization (AC)",
        "student.learning_style_active_exp": "Active Experimentation (AE)"
      }
    },
    "learning_preference_section": {
      "learning_preference_description": "Learning Preference Description",
      "learning_preference_group": "Learning In Groups (Collaborative Learning)",
      "learning_preference_individual": "Learning Individually (Independent Learning)",
      "learning_preference_like_students": "Learning with Like Students (Homogeneous Grouping)",
      "learning_preference_diverse_students": "Learning with Diverse Students (Heterogeneous Grouping)",
      "learning_preference_teacher_centered": "Teacher-Centered vs. Student-Centered Learning",
      "learning_preference_structured": "Structured vs Flexible Learning",
      "learning_preference_technology_enhanced": "Traditional vs Technology-Enhanced Learning",
      "learning_preference_by_doing": "Learning by Doing vs Learning by Observing",
      "bounds": {
        "teacher_centered_lower": "Teacher-Centered",
        "teacher_centered_upper": "Student-Centered",
        "structured_lower": "Structured",
        "structured_upper": "Flexible",
        "technology_enhanced_lower": "Traditional",
        "technology_enhanced_upper": "Technology-Enhanced",
        "by_doing_lower": "Learning by Doing",
        "by_doing_upper": "Learning by Observing"
      },
      "tooltips": {
        "learning_preference_group": "<b>Collaborative Learning:</b> Students prefer working in groups, learning through discussions, sharing ideas, and solving problems collectively.",
        "learning_preference_individual": "<b>Independent Learning:</b> Students prefer to study alone, set their own pace, and take responsibility for their own learning.",
        "learning_preference_like_students": "<b>Homogeneous Grouping:</b> Students are grouped based on similar abilities, interests, or learning styles, allowing them to work with peers who have similar strengths or challenges.",
        "learning_preference_diverse_students": "<b>Heterogeneous Grouping:</b> Students of varying abilities, backgrounds, and interests are grouped together to promote diversity, collaborative problem-solving, and social learning.",
        "learning_preference_teacher_centered": "<b>Teacher-Centered vs. Student-Centered Learning:</b> Some students prefer teacher-led instruction (lectures, direct teaching), while others thrive in environments where they take an active role in their learning (projects, inquiry-based learning).",
        "learning_preference_structured": "<b>Structured vs. Flexible Learning:</b> Students might prefer a highly structured environment with clear guidelines and expectations, or a more flexible setting where they have the freedom to explore topics in their own way.",
        "learning_preference_technology_enhanced": "<b>Technology-Enhanced Learning:</b> Preferences for using technology (e.g., online resources, digital tools) versus traditional methods (e.g., textbooks, paper-and-pencil tasks).",
        "learning_preference_by_doing": "<b>Learning by Doing vs. Learning by Observing:</b> Some students prefer hands-on activities, experiments, and real-world applications, while others may prefer to observe, reflect, and analyze before engaging directly."
      }
    },
    "other_information_section": {
      "subsections": {
        "eyesight": "Eyesight",
        "adhd": "ADHD",
        "autism": "Autism",
        "depression": "Depression"
      },
      "tooltips": {
        "eyesight": "Eyesight according to <a> W.H.O ICD-10 Classifications </a>",
        "autism": "Autism according to <a> W.H.O ICD-10 Classifications </a>",
        "depression": "Depression according to <a> W.H.O ICD-10 Classifications </a>",
        "adhd": "ADHD according to <a> W.H.O ICD-10 Classifications </a>"
      },
      "professional_diagnosis": "Was this a professional Diagnosis?",
      "eyesight": {
        "comments": "Eyesight Comments"
      },
      "adhd": {
        "comments": "ADHD Comments"
      },
      "autism": {
        "comments": "Autism Comments"
      },
      "depression": {
        "comments": "Depression Comments"
      }
    },
    "parent_information_section": {
      "parent_one_education": "Parent One Education Level",
      "parent_two_education": "Parent Two Education Level",
      "parent_one_occupation": "Parent One Occupation",
      "parent_two_occupation": "Parent Two Occupation"
    }
  },

  "show": {
    "title": "Student Profile",
    "dob": "Date of Birth:",
    "primary_language": "Primary Language:",
    "secondary_language": "Secondary Language:",
    "gender": "Gender:",
    "country": "Country:",
    "religion": "Religion:",
    "race": "Race:",
    "citizenships": "Citizenship(s):",
    "origin_country": "Country of Origin:",
    "missing_attribute": "N/A",
    "parent_information": "Parent Information",
    "student_assessment": {
      "title": "Student Assessments",
      "interested_subjects_empty": "No interested subjects",
      "tooltips": {
        "naplan": "The National Assessment Program – Literacy and Numeracy",
        "wiscV": "Wechsler Intelligence Scale for Children, Fifth Edition",
        "wiatIV": "Wechsler Individual Achievement Test, Fourth Edition",
        "waisIV": "Wechsler Adult Intelligence Scale, Fourth Edition",
        "qualitativeAssessment": "Overall School Grade",
        "interestedSubjects": "Areas of Academic Interest",
        "aeas": "Australian Education Assessment Services",
        "gat": "The General Achievement Test "
      },
      "subsections": {
        "naplan": "Naplan",
        "wiscV": "WISC-V",
        "wiatIV": "WIAT-IV",
        "waisIV": "WAIS-IV",
        "qualitativeAssessment": "Qualitative Assessment",
        "interestedSubjects": "Interested Subjects",
        "aeas": "AEAS",
        "gat": "GAT (VIC)"
      }
    },
    "learning_styles": {
      "title": "Learning Styles",
      "description": "Description",
      "subsections": {
        "vark": "$t(form.learning_style_section.subsections.vark)",
        "gardners_multiple_intelligences": "$t(form.learning_style_section.subsections.gardners_multiple_intelligences)",
        "kolbs_experiential_learning_theory": "$t(form.learning_style_section.subsections.kolbs_experiential_learning_theory)"
      }
    },
    "learning_preference": {
      "title": "Learning Preferences",
      "description": "Description"
    },
    "naplan": {
      "naplanScoreNumeracy": "Numeracy",
      "naplanScoreReading": "Reading",
      "naplanScoreWriting": "Writing",
      "naplanScoreGrammar": "Grammar",
      "naplanScoreSpelling": "Spelling"
    },
    "comments": "Comments",
    "other_information": {
      "title": "Additional Support Needs",
      "subsections": {
        "adhd": "ADHD",
        "autistic": "Autism",
        "depression": "Depression",
        "eyesight": "Eyesight"
      }
    }
  }
}
